<customer-wrapper [showBreadcrumb]="false">
  <ng-container main-content>
    <div class="metrics-dashboard">
      <div class="metrics-header">
        <div class="page-title">
          <img src="assets/icons/metrics-dashboard.svg">
          <div>Metrics Dashboard</div>
        </div>
        <div class="range-selector">
          <button *ngFor="let range of ranges"
                  class="range-button"
                  [class.active]="range === selectedRange"
                  (click)="selectRange(range)">
            {{ range.label }}
          </button>
        </div>
      </div>

      <div class="current-hint" *ngIf="currentMonthHint && data.length">
        <img src="assets/icons/information-outline.svg">
        <span>{{ currentMonthHint }}</span>
      </div>

      <div class="position-relative">
        <div class="loading-shade" *ngIf="isLoading">
          <mat-spinner></mat-spinner>
        </div>

        <section class="kpi-row">
          <count-card label="Current Storage (GB)" [count]="currentStorageGb" icon="database" subtext="latest month"></count-card>
          <count-card class="clickable" (click)="openBreakdown('incidents')" label="Incidents Created" [count]="incidentsTotal" icon="bulletlist" [subtext]="rangeLabel"></count-card>
          <count-card class="clickable" (click)="openBreakdown('uniqueUsers')" label="Unique Users" [count]="uniqueUsers" icon="group" subtext="deduplicated"></count-card>
          <count-card class="clickable" (click)="openBreakdown('video')" label="Video Streamed (mins)" [count]="videoMinutes" icon="camera" [subtext]="rangeLabel"></count-card>
          <count-card class="clickable" (click)="openBreakdown('redaction')" label="Redaction (mins)" [count]="redactionMinutes" icon="seatbelt" [subtext]="rangeLabel"></count-card>
          <count-card class="clickable" (click)="openBreakdown('clipsAdded')" label="Clips Added" [count]="clipsAddedTotal" icon="slideshow" [subtext]="rangeLabel"></count-card>
          <count-card class="clickable" (click)="openBreakdown('clipData')" label="Clip Data Added (GB)" [count]="clipDataGb" icon="download" [subtext]="rangeLabel"></count-card>
        </section>

        <section class="chart-card featured" *ngIf="storageChart">
          <div class="chart-body">
            <x-y-graph
              [chartTitle]="storageChart.title"
              [chartId]="storageChart.id"
              [graphPair]="storageChart.graphPair"
              [domainMonths]="storageChart.domainMonths"
              [highlightCurrentMonth]="false"
              [showKey]="false">
            </x-y-graph>
          </div>
        </section>

        <section class="charts-grid" *ngIf="charts.length">
          <div class="chart-card" *ngFor="let chart of charts">
            <div class="chart-body">
              <x-y-graph
                [chartTitle]="chart.title"
                [chartId]="chart.id"
                [graphPair]="chart.graphPair"
                [domainMonths]="chart.domainMonths"
                [highlightCurrentMonth]="false"
                [showKey]="false">
              </x-y-graph>
            </div>
          </div>
        </section>
      </div>
    </div>

    <div class="breakdown-overlay" *ngIf="breakdownOpen" (click)="closeBreakdown()">
      <div class="breakdown-modal" (click)="$event.stopPropagation()">
        <div class="breakdown-header">
          <div class="breakdown-title">{{ breakdownTitle }} — {{ rangeLabel }}</div>
          <button class="breakdown-close" type="button" (click)="closeBreakdown()">✕</button>
        </div>
        <div class="breakdown-body">
          <div class="breakdown-message" *ngIf="breakdownLoading">Loading…</div>
          <table class="breakdown-table" *ngIf="!breakdownLoading && breakdownRows.length">
            <thead>
              <tr><th>Tenant</th><th class="value-col">{{ breakdownTitle }}</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of breakdownRows">
                <td>{{ row.tenant }}</td>
                <td class="value-col">{{ row.display }}</td>
              </tr>
            </tbody>
          </table>
          <div class="breakdown-message" *ngIf="!breakdownLoading && !breakdownRows.length">
            No tenant activity for this metric in the selected range.
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</customer-wrapper>
